/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from "@ngrx/store";
import { ConfigurationLocationReturnCodes } from "../../models/configuration-location-return-codes";
import { ConfigurationLocationActionNames } from "./configuration-location-action-names";

export const GetFolderPath = createAction(
    ConfigurationLocationActionNames.GetFolder()
);

export const GetFolderSuccess = createAction(
    ConfigurationLocationActionNames.GetFolderSuccess(),
    props<{ folderPath: string, statusCode: ConfigurationLocationReturnCodes }>()
);